import { combineReducers } from 'redux';
import appState from './appState';
import metadata from './subscriptionMetadata';
import checkout from './checkout';
import { persistReducer } from 'redux-persist';
import { appStatePersistConfig } from '../persistConfig';

const appReducer = combineReducers({
  appState: persistReducer(appStatePersistConfig, appState),
  metadata,
  checkout,
});

export default appReducer;
